document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.kcs').forEach(initKlaviyoCarSignup);
});

function initKlaviyoCarSignup(section) {
  if (section.dataset.initialized === '1') return;
  section.dataset.initialized = '1';

  const publicKey = section.dataset.klaviyoPublicKey;
  const listId = section.dataset.klaviyoListId;
  const brandApi = section.dataset.brandApi;
  const seriesApi = section.dataset.seriesApi;
  const modelApi = section.dataset.modelApi;
  const successMessage =
    section.dataset.successMessage || 'Bitte prüfe dein Postfach.';
  const errorMessage =
    section.dataset.errorMessage || 'Es ist ein Fehler aufgetreten.';

  const form = section.querySelector('.kcs__form');
  const messageBox = section.querySelector('.kcs__message');
  const submitBtn = section.querySelector('.kcs__submit');

  const firstNameInput = form.querySelector('input[name="first_name"]');
  const emailInput = form.querySelector('input[name="email"]');
  const consentInput = form.querySelector('input[name="consent"]');

  const brandWrap = section.querySelector('.cs-select--brand');
  const seriesWrap = section.querySelector('.cs-select--series');
  const modelWrap = section.querySelector('.cs-select--model');

  const brandSelect = setupCustomSelect(brandWrap, onBrandSelect);
  const seriesSelect = setupCustomSelect(seriesWrap, onSeriesSelect);
  const modelSelect = setupCustomSelect(modelWrap, onModelSelect);

  brandSelect.reset('Automarke wählen');
  seriesSelect.reset('Serie wählen');
  modelSelect.reset('Modell wählen');

  if (!publicKey || !listId) {
    setMessage('Bitte Klaviyo Public Key und List ID im Section-Editor pflegen.', 'error');
    submitBtn.disabled = true;
    return;
  }

  loadBrands();

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    clearMessage();

    if (!isFormValid()) {
      setMessage('Bitte alle Pflichtfelder ausfüllen und Consent bestätigen.', 'error');
      return;
    }

    setLoading(true);

    const payload = buildPayload();

    try {
      await createOrUpdateClientProfile(publicKey, payload.profile);
      await createClientSubscription(publicKey, payload.subscription);

      form.reset();
      brandSelect.reset('Automarke wählen');
      seriesSelect.reset('Serie wählen');
      modelSelect.reset('Modell wählen');
      await loadBrands();

      setMessage(successMessage, 'success');
    } catch (error) {
      console.error('Klaviyo signup error:', error);
      setMessage(extractErrorMessage(error, errorMessage), 'error');
    } finally {
      setLoading(false);
    }
  });

  function isFormValid() {
    const firstName = firstNameInput.value.trim();
    const email = emailInput.value.trim();

    return Boolean(
      firstName &&
      isValidEmail(email) &&
      consentInput.checked &&
      brandSelect.value &&
      seriesSelect.value &&
      modelSelect.value
    );
  }

  async function loadBrands() {
    if (!brandApi) {
      setMessage('Brand API URL fehlt.', 'error');
      return;
    }

    try {
      const response = await fetch(brandApi, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Brand API konnte nicht geladen werden.');

      const data = await response.json();
      brandSelect.setOptions(data);
      brandSelect.enable();
    } catch (error) {
      console.error(error);
      setMessage('Automarken konnten nicht geladen werden.', 'error');
    }
  }

  async function onBrandSelect(brandTag) {
    seriesSelect.reset('Serie wählen');
    modelSelect.reset('Modell wählen');

    if (!brandTag || !seriesApi) return;

    try {
      const response = await fetch(
        `${seriesApi}?brand=${encodeURIComponent(brandTag)}`,
        { credentials: 'same-origin' }
      );

      if (!response.ok) throw new Error('Series API konnte nicht geladen werden.');

      const data = await response.json();
      seriesSelect.setOptions(data);
      seriesSelect.enable();
    } catch (error) {
      console.error(error);
      setMessage('Serien konnten nicht geladen werden.', 'error');
    }
  }

  async function onSeriesSelect(seriesTag) {
    modelSelect.reset('Modell wählen');

    if (!seriesTag || !modelApi || !brandSelect.value) return;

    try {
      const response = await fetch(
        `${modelApi}?brand=${encodeURIComponent(brandSelect.value)}&series=${encodeURIComponent(seriesTag)}`,
        { credentials: 'same-origin' }
      );

      if (!response.ok) throw new Error('Model API konnte nicht geladen werden.');

      const data = await response.json();
      modelSelect.setOptions(data);
      modelSelect.enable();
    } catch (error) {
      console.error(error);
      setMessage('Modelle konnten nicht geladen werden.', 'error');
    }
  }

  function onModelSelect() {}

  function buildPayload() {
    const firstName = firstNameInput.value.trim();
    const email = emailInput.value.trim();

    const brand = brandSelect.value;
    const series = seriesSelect.value;
    const model = modelSelect.value;
    const vehicleLabel = [brand, series, model].filter(Boolean).join(' / ');

    return {
      profile: {
        data: {
          type: 'profile',
          attributes: {
            email: email,
            first_name: firstName,
            properties: {
              car_brand: brand,
              car_series: series,
              car_model: model,
              car_vehicle_label: vehicleLabel,
              signup_source: 'shopify_newsletter_car_section'
            }
          }
        }
      },
      subscription: {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'shopify_newsletter_car_section',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  properties: {
                    car_brand: brand,
                    car_series: series,
                    car_model: model,
                    car_vehicle_label: vehicleLabel
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      }
    };
  }

  function setLoading(isLoading) {
    section.classList.toggle('kcs__loading', isLoading);
    submitBtn.disabled = isLoading;
    submitBtn.textContent = isLoading ? 'Wird gesendet ...' : 'Jetzt anmelden';
  }

  function setMessage(text, type) {
    messageBox.textContent = text;
    messageBox.className = 'kcs__message';
    messageBox.classList.add(type === 'success' ? 'is-success' : 'is-error');
  }

  function clearMessage() {
    messageBox.textContent = '';
    messageBox.className = 'kcs__message';
  }
}

async function createOrUpdateClientProfile(publicKey, body) {
  const response = await fetch(
    `https://a.klaviyo.com/client/profiles/?company_id=${encodeURIComponent(publicKey)}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2026-01-15'
      },
      body: JSON.stringify(body)
    }
  );

  if (!response.ok) {
    throw await buildKlaviyoError(response);
  }

  return response.json().catch(() => ({}));
}

async function createClientSubscription(publicKey, body) {
  const response = await fetch(
    `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicKey)}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2026-01-15'
      },
      body: JSON.stringify(body)
    }
  );

  if (!response.ok) {
    throw await buildKlaviyoError(response);
  }

  return response.json().catch(() => ({}));
}

async function buildKlaviyoError(response) {
  let message = `HTTP ${response.status}`;

  try {
    const data = await response.json();

    if (data && data.errors && data.errors.length) {
      message = data.errors
        .map((item) => item.detail || item.title)
        .filter(Boolean)
        .join(' | ');
    } else if (data && data.message) {
      message = data.message;
    }
  } catch (error) {}

  return new Error(message);
}

function extractErrorMessage(error, fallback) {
  if (!error) return fallback;
  if (typeof error.message === 'string' && error.message.trim()) return error.message;
  return fallback;
}

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function setupCustomSelect(wrapper, onSelect) {
  const trigger = wrapper.querySelector('.cs-select__trigger');
  const optionsEl = wrapper.querySelector('.cs-select__options');

  let currentValue = null;

  trigger.addEventListener('click', () => {
    if (wrapper.classList.contains('cs-select--disabled')) return;
    wrapper.classList.toggle('open');
  });

  optionsEl.addEventListener('click', (event) => {
    if (event.target.tagName !== 'LI') return;

    currentValue = event.target.dataset.value;
    trigger.textContent = event.target.textContent;
    wrapper.classList.remove('open');

    if (typeof onSelect === 'function') {
      onSelect(currentValue);
    }
  });

  document.addEventListener('click', (event) => {
    if (!wrapper.contains(event.target)) {
      wrapper.classList.remove('open');
    }
  });

  return {
    setOptions(items) {
      optionsEl.innerHTML = '';

      (items || []).forEach((item) => {
        const li = document.createElement('li');
        li.textContent = item.name;
        li.dataset.value = item.tag || item.name;
        optionsEl.appendChild(li);
      });
    },
    enable() {
      wrapper.classList.remove('cs-select--disabled');
    },
    reset(label) {
      trigger.textContent = label;
      optionsEl.innerHTML = '';
      currentValue = null;
      wrapper.classList.add('cs-select--disabled');
      wrapper.classList.remove('open');
    },
    get value() {
      return currentValue;
    }
  };
}